module.exports = __webpack_public_path__ + "static/img/2724_phase_function_Paper_Points.425fcc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2724_phase_function_Paper_Points.png
// module id = zwW7
// module chunks = 0